module.exports = __webpack_public_path__ + "assets/img/windows_success_icon.81bbd070.svg";